import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stage, show"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H18.25C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75ZM19.8102 17.8712L18.0938 16.1576C17.6719 15.7365 17.1002 15.5 16.5041 15.5H7.49264C6.8959 15.5 6.32361 15.7371 5.90165 16.159L4.18963 17.871C4.59415 18.2605 5.14411 18.5 5.75 18.5H18.25C18.8558 18.5 19.4057 18.2606 19.8102 17.8712Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStage;
